import * as movement from './movement.js';

export default {
    movement,
};

if (window.EQLAPP === undefined) {
    window.EQLAPP = {};
}

// Global Access
if (window.EQLAPP) {

    // Movement
    window.EQLAPP.MOVEMENT = window.EQLAPP.MOVEMENT || {};
    Object.entries(movement).forEach(([key, value]) => {
        window.EQLAPP.MOVEMENT[key] = value;
    });

}